import type { VehicleType } from "@slfinrtl/ui-bff-routes"

export const areUsedConditionInputsDisabled = ({ vehicleType }: { vehicleType: VehicleType }): boolean =>
	vehicleType === "NEW_CAR"
